<template>
  <b-card title="لیست پیام های پین شده">
    <b-row>
      <b-col class="table-size">
        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
            :no-local-sorting="true"
        >
          <template #cell(user)="data">
             {{ data.value.Name }}
             {{ data.value.Family }}
          </template>
          <template #cell(MessageDateTime)="data">
            {{data.value | date }}-
            {{new Date(data.value).toLocaleTimeString('en-GB') | time}}
          </template>
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <feather-icon
                  icon="PaperclipIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  :class="data.item.Pinned?'text-primary':'text-gray'"
                  @click="pinMessage(data.item.Id,!data.item.Pinned)"
              />
            </div>
          </template>
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>

export default {
  name: 'messageReports',
  components: {  },
  data() {
    return {
      totalRows: 10,
      loading: false,
      showModal: false,
      editingItem: null,
      filterOptions: {
        Page: 1,
        PerPage: 10,
        MessageGroupId:null
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'MessageText',
          label: 'پیام',
        },
        {
          key: 'User',
          label: 'ارسال کننده',
        },
         {
          key: 'MessageDateTime',
          label: 'تاریخ ارسال پیام',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.get(this.$api.messenger.GetPinMessage, { params: this.filterOptions })
          .then(res => {
            this.totalRows= res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    pinMessage(id,pinned) {
      let title = ''
      if(pinned){
        title='ایا مطمئن هستید این پیام پین شود'
      }else title = 'ایا مطمئن هستید این پیام از پین خارج شود'
      this.$bvModal.msgBoxConfirm(title, {
        title: 'پین کردن پیام',
        size: 'sm',
        okVariant: 'info',
        okTitle: 'تایید',
        cancelTitle: 'انصراف',
        cancelVariant: 'outline-secondary',
        hideHeaderClose: false,
        centered: true,
        modalClass: 'modal-danger modal-remove-confirm',
      }).then(confirm => {
        if (confirm) {
          this.$http.post(this.$api.messenger.setPinMessage, { Id: id , Pinned:pinned }).then(() => {
            this.update()
          })
        }
      })
    },
    edit(item) {
      this.editingItem = item
      this.showModal= true
    }
  }
}
</script>
